import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useI18n } from '../../i18n/I18nContext';
import { localizePath, stripLocalePrefix } from '../../i18n/localeRouting';

function upsertLink(rel: string, hreflang: string | null, href: string) {
  const selector = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(selector) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    if (hreflang) el.hreflang = hreflang;
    document.head.appendChild(el);
  }
  el.href = href;
}

export function SeoLinks() {
  const { locale } = useI18n();
  const location = useLocation();

  useEffect(() => {
    document.documentElement.lang = locale;

    const origin = window.location.origin;
    const stripped = stripLocalePrefix(location.pathname);

    const hrefEn = `${origin}${localizePath(stripped, 'en')}`;
    const hrefEs = `${origin}${localizePath(stripped, 'es')}`;
    const canonical = `${origin}${localizePath(stripped, locale)}`;

    upsertLink('canonical', null, canonical);
    upsertLink('alternate', 'en', hrefEn);
    upsertLink('alternate', 'es', hrefEs);
    upsertLink('alternate', 'x-default', hrefEn);
  }, [locale, location.pathname]);

  return null;
}
